import { Autoplay, Navigation, Pagination, Keyboard, EffectFade, Mousewheel } from "swiper";

export const logoSliderOptions = {
  modules: [Navigation, Pagination, Autoplay, EffectFade],
  slidesPerView: 1,
  spaceBetween: 30,
  grabCursor: true,
  centeredSlides: true,
  pagination: {
    el: ".image-swiper-pagination",
    clickable: true,
    type: "bullets",
  },
  loop: true,
  autoplay: {
    delay: 0.5,
    disableOnInteraction: false,
  },
  speed: 3000,
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 60,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 85,
    },
    1400: {
      slidesPerView: 5,
      spaceBetween: 85,
    }
  },
};

